import { useRef, useEffect } from 'react';
import { useProject } from '@atlassian/jira-business-entity-project-hook';
import {
	useQuickFilters,
	useFilters,
	useFilteredViewContextInput,
} from '@atlassian/jira-business-filters';
import { useGroupBy } from '../../group-by';
import { useHierarchyStore } from '../hierarchy-store';

export const useResetItems = () => {
	const { sorting } = useFilteredViewContextInput({ view: 'list' });
	const { jql } = useFilters();
	const { quickFiltersJql } = useQuickFilters();
	const [groupByFieldId] = useGroupBy();
	const [
		{
			hierarchyData: { loading },
		},
		{ resetCache, clearHierarchyData },
	] = useHierarchyStore();

	const projectData = useProject();
	const projectKey = projectData.key;

	const lastSorting = useRef({ ...sorting });
	const lastJqlFiltering = useRef(jql);
	const lastQuickFilterJql = useRef(quickFiltersJql);
	const lastGroupByFieldId = useRef(groupByFieldId);

	useEffect(() => {
		if (loading) {
			return;
		}
		const hasSortingChanged =
			lastSorting.current.sortBy !== sorting.sortBy ||
			lastSorting.current.direction !== sorting.direction;
		const hasFilteringChanged =
			lastJqlFiltering.current !== jql || lastQuickFilterJql.current !== quickFiltersJql;
		const hasGroupByFieldIdChanged = lastGroupByFieldId.current !== groupByFieldId;

		if (hasGroupByFieldIdChanged || hasSortingChanged || hasFilteringChanged) {
			resetCache();

			// update last reference
			lastSorting.current = sorting;
			lastJqlFiltering.current = jql;
			lastQuickFilterJql.current = quickFiltersJql;
			lastGroupByFieldId.current = groupByFieldId;
		}
	}, [groupByFieldId, loading, sorting, resetCache, jql, quickFiltersJql]);

	useEffect(() => {
		// Reset hierarchy data when navigate across projects
		clearHierarchyData();
	}, [projectKey, clearHierarchyData]);
};
